import { Container } from "pixi.js";
import { LoaderLayer } from "./layer/LoaderLayer";
import { NotificationLayer } from "./layer/NotificationLayer";
import { ViewableLayer } from "./layer/ViewableLayer";
import { BaseView } from "./viewable/BaseView";
import { Viewable } from "./viewable/Viewable";
import { SceneManagerConfig } from "./SceneManagerConfig";
import { TelemetryLayer } from "./layer/TelemetryLayer";

export class SceneManager {
    public readonly notificationsLayer: NotificationLayer;
    public readonly viewableLayer: ViewableLayer;
    public readonly loaderLayer: LoaderLayer;
    public readonly telemetryLayer: TelemetryLayer;

    public constructor(stage: Container, config?: SceneManagerConfig) {
        const viewableLayer = config?.viewableLayerType ?? new ViewableLayer();
        const notificationLayer = config?.notificationLayerType ?? new NotificationLayer();
        const loaderLayer = config?.loaderLayerType ?? new LoaderLayer();
        const telemetryLayer = config?.telemetryLayer ?? new TelemetryLayer();

        this.viewableLayer = viewableLayer;
        stage.addChild(this.viewableLayer);
        this.notificationsLayer = notificationLayer;
        stage.addChild(this.notificationsLayer);
        this.loaderLayer = loaderLayer;
        stage.addChild(this.loaderLayer);
        this.telemetryLayer = telemetryLayer;
        stage.addChild(this.telemetryLayer);
    }

    private async showViewableAsyncInternal<TResult>(parent: Container, viewable: Viewable<TResult>): Promise<TResult> {
        var viewableContainer = viewable.view;
        parent.addChild(viewableContainer);
        viewableContainer.start();
        function removeViewableContainer(view: BaseView<TResult>, parent: Container) {
            parent.removeChild(view);
            view.destroy({ children: true, texture: false, baseTexture: false });
        }
        return new Promise<TResult>((resolve, reject) => {
            viewable.operation.then((result) => {
                removeViewableContainer(viewableContainer, parent);
                resolve(result);
            }, (reason) => {
                removeViewableContainer(viewableContainer, parent);
                reject(reason);
            });
        });
    }

    public async showViewableAsync<TResult>(viewable: Viewable<TResult>): Promise<TResult> {
        return await this.showViewableAsyncInternal<TResult>(this.viewableLayer, viewable);
    }
}
